<script>
export default {
    name: 'HelpPage',
};
</script>

<script setup>
import CardsPage from '@/pages/components/cards-page.vue';
import { instance } from '@/api/api.ts';
</script>

<template>
    <cards-page
        :title="$t('header breadcrumb help')"
        :fetch="() => instance.get('/help')"
    />
</template>
